<template>
  <div class="breadcrumbs">
    <a
      :href="`https://fietsambassade.gent.be/${locale}`"
      class="float-right d-none d-md-block"
      target="_BLANK"
      >{{ this.$t('return-to-the-website') }}</a
    >
    <a
      :href="`https://fietsambassade.gent.be/${locale}`"
      class="d-md-none text-center"
      target="_BLANK"
      >{{ this.$t('return-to-the-website') }}</a
    >
    <p>
      <span v-for="(breadCrumb, index) in breadCrumbs" :key="breadCrumb.index">
        <router-link :to="`/${$i18n.locale}${breadCrumb.path}`">{{
          breadCrumb.title
        }}</router-link>

        <span
          v-if="
            index < breadCrumbs.length - 1 ||
              (index < breadCrumbs.length && currentpage)
          "
          class="seperator"
        >
          &nbsp;
          <font-awesome-icon icon="chevron-right" />
        </span>
      </span>
      <span class="currentpage">{{ currentpage }}</span>
    </p>
  </div>
</template>
<script>
import i18n from '@/locales/index'
export default {
  props: {
    breadCrumbs: {
      type: Array,
      required: false,
      default: function() {
        return [
          { page: 'index', title: this.$t('general.bikeRental'), path: '/' }
        ]
      }
    },

    currentpage: {
      type: String,
      default: function() {
        return null
      }
    }
  },
  computed: {
    locale: function() {
      return i18n.locale
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumbs {
  min-width: 100%;
}
p {
  font-size: 18px;
  font-size: 0.9rem;
}
.seperator {
  font-size: 0.5rem;
  line-height: 20px;
  vertical-align: middle;
  padding-left: 6px;
  padding-right: 6px;
  color: #333333;
}
.currentpage {
  color: #070808;
}
</style>
